import Box from 'components/shared/Box'
import Button from 'components/shared/Button'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { HOME_LINK, UNLIMITED_LANDING_PAGE } from 'constants/links'
import { FormattedMessage } from 'react-intl'
import { unlimitedCardFirstStep } from 'routes/basenames'

interface RenewStatusBoxProps {
    status: 'used' | 'expired'
}

const RenewStatusBox = ({ status }: RenewStatusBoxProps) => (
    <Section>
        <Box direction="column" gap={32}>
            {status === 'used' && (
                <>
                    <Text variant="heading2" color="secondary_500">
                        <FormattedMessage
                            id="annual.renew.verification_status_used"
                            defaultMessage="Ta karta została już odnowiona"
                        />
                    </Text>
                    <Text variant="body" color="grayscale_900">
                        <FormattedMessage
                            id="annual.renew.verification_status_used_details"
                            defaultMessage="Aktywujemy ją automatycznie, kiedy poprzednia karta straci ważność."
                        />
                    </Text>
                    <Button
                        variant="primary"
                        href={HOME_LINK}
                        testId="renew-renewed-redirect-homepage"
                    >
                        <FormattedMessage
                            id="global.btn.back_onto_homepage"
                            defaultMessage="Wróć na stronę główną"
                        />
                    </Button>
                </>
            )}
            {status === 'expired' && (
                <>
                    <Text variant="heading2" color="secondary_500">
                        <FormattedMessage
                            id="annual.renew.verification_status_outdated"
                            defaultMessage="Czas na odnowienie karty minął"
                        />
                    </Text>
                    <Text variant="body" color="grayscale_900">
                        <FormattedMessage
                            id="annual.renew.verification_status_outdated_details"
                            defaultMessage="Nic straconego, wciąż możesz kupić nową kartę i relaksować się w tropikach bez ograniczeń!"
                        />
                    </Text>
                    <Box
                        direction={['column', 'row']}
                        gap={[8, 12]}
                        isFullWidth
                    >
                        <Button
                            variant="primary"
                            onClick={() => {
                                window.location.replace(unlimitedCardFirstStep)
                            }}
                            testId="renew-expired-redirect-unlimited-crator"
                        >
                            <FormattedMessage
                                id="annual.renew.btn_buy_card"
                                defaultMessage="Kup kartę Unlimited"
                            />
                        </Button>
                        <Button
                            variant="borderPrimary"
                            href={UNLIMITED_LANDING_PAGE}
                            testId="renew-expired-redirect-unlimited-landing"
                        >
                            <FormattedMessage
                                id="global.btn.learn_more"
                                defaultMessage="Dowiedz się więcej"
                            />
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    </Section>
)

export default RenewStatusBox
